import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { RatingService } from 'app/shared/services/rating/rating.service';
import { SubscriptionBaseComponent } from 'app/shared/subscription-base/subscription-base-component';

@Component({
  selector: 'app-voting-bars',
  templateUrl: './voting-bars.component.html',
  styleUrls: ['./voting-bars.component.scss']
})
export class VotingBarsComponent extends SubscriptionBaseComponent implements OnInit {

  @Input() id!: string;
  @Input() starSize!: number;
  @Output() ratingEvent: EventEmitter<{ rating: number, disturbing: number, id: string}> = new EventEmitter();

  rating: number=1;
  disturbing: number=1;

  constructor(private ratingService: RatingService) {
    super();
  }

  ngOnInit(): void {
    this.initSub();
  }

  ratingValueChanged(value: number): void {
    this.rating = value;
    this.emitEvent();
  }

  disturbingValueChanged(value: number): void {
    this.disturbing = value;
    this.emitEvent();
  }

  private emitEvent(): void {
    this.ratingEvent.emit({ rating: this.rating, disturbing: this.disturbing, id: this.id});
  }

  private initSub(): void {
    this.subscription.add(this.ratingService.ratingSubject.subscribe({
      next: value => {
        this.rating = value;
        this.disturbing = value;
      }
    }))
  }
}
